<template>
  <card-item card="item_notification" :tabs="tabs" :activeTab="activeTab"  @setTab="setTab"  :id="id">
  </card-item>
</template>
<script>
export default {
  props: ["id"],
  data() {
    return {

      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
   methods: {
    setTab(val){
      this.activeTab = val;
    }
  },
};
</script>